import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './../../../templates/forms/modals/employee-list.component.html',
})
export class EmployeeListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "EmployeeListGrid"

  employeeList: any[] = [];
  searchFields: any[] = ['EMP_NAME', 'EMP_NO'];
  public searchString;

  constructor(
      public langService: LangService
    , private dataService: DataLoadService
    , public gridService: GridService) {
    this.colObj = [
      { headerName: 'Name', field: 'EMP_NAME', sortable: true, resizable: true, hide: false },
      { headerName: 'Job Title', field: 'JOBTITLE', sortable: true, resizable: true, hide: false },
      { headerName: 'BU Name', field: 'BU_NAME', sortable: true, resizable: true, hide: false },
      { headerName: 'Emp ID', field: 'EMP_ID', sortable: true, resizable: true, hide: false },
      { headerName: 'Emp NO', field: 'EMP_NO', sortable: true, resizable: true, hide: false },
      { headerName: 'Jobtitle No', field: 'JOBTITLE_NO', sortable: true, resizable: true, hide: false },
    ];
   }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
      this.grid = grid;
      this.gridService.sizeColumnsToFit(grid, this.gridId);
      // this.dataService.getEmployees()
      //       .subscribe(arg => { this.employeeList = arg.body });

      this.dataService.load('FG_IN_COMM_INT_EMP_LIST').subscribe(results=>{
        this.employeeList = results.body;
      })
    }
    itemClick(_item) {
      this.modalShow = false; 
      this.dataObj=_item;
      this.submit.next(_item);
    }

}
